import React from "react";
import { BRANDING } from "../config/branding";
import InfoTip from "../components/InfoTip";
import {
  TRUST_ATTRIBUTION,
  TRUST_COVERAGE,
  TRUST_DISCLAIMER_SHORT,
  TRUST_FOOTER_LINKS,
} from "./trustContent";

/**
 * Slim site footer for trust links, disclaimer, coverage, attribution.
 */
export default function SiteFooter({ onNavigate, compact = false }) {
  return (
    <footer
      className={`v2-site-footer${compact ? " v2-site-footer--compact" : ""}`}
      role="contentinfo"
    >
      <div className="v2-site-footer-main">
        <p className="v2-site-footer-disclaimer">{TRUST_DISCLAIMER_SHORT}</p>
        <nav className="v2-site-footer-nav" aria-label="Legal and about">
          {TRUST_FOOTER_LINKS.map((link) => (
            <button
              key={link.id}
              type="button"
              className="v2-site-footer-link"
              onClick={() => onNavigate?.(link.id)}
            >
              {link.label}
            </button>
          ))}
        </nav>
      </div>
      <div className="v2-site-footer-meta">
        <span className="v2-info-tip--label v2-site-footer-coverage">
          Coverage: {TRUST_COVERAGE.shortLabel}
          <InfoTip text={TRUST_COVERAGE.summary} label="About coverage" />
        </span>
        <span className="v2-site-footer-dot" aria-hidden>
          ·
        </span>
        <span className="v2-info-tip--label v2-site-footer-attr">
          Data: DfE, Ofsted · Maps: OSM
          <InfoTip text={TRUST_ATTRIBUTION.short} label="About data sources" />
        </span>
        <span className="v2-site-footer-dot" aria-hidden>
          ·
        </span>
        <span className="v2-site-footer-brand">{BRANDING.appName}</span>
      </div>
    </footer>
  );
}
